/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as MasterRouteImport } from './routes/master'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResultIdRouteImport } from './routes/result.$id'
import { Route as MasterCategoriesRouteImport } from './routes/master/categories'
import { Route as MasterBrandsRouteImport } from './routes/master/brands'
import { Route as MasterBrandLinesRouteImport } from './routes/master/brand-lines'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterRoute = MasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultIdRoute = ResultIdRouteImport.update({
  id: '/result/$id',
  path: '/result/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterCategoriesRoute = MasterCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => MasterRoute,
} as any)
const MasterBrandsRoute = MasterBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => MasterRoute,
} as any)
const MasterBrandLinesRoute = MasterBrandLinesRouteImport.update({
  id: '/brand-lines',
  path: '/brand-lines',
  getParentRoute: () => MasterRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/master': typeof MasterRouteWithChildren
  '/settings': typeof SettingsRoute
  '/master/brand-lines': typeof MasterBrandLinesRoute
  '/master/brands': typeof MasterBrandsRoute
  '/master/categories': typeof MasterCategoriesRoute
  '/result/$id': typeof ResultIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/master': typeof MasterRouteWithChildren
  '/settings': typeof SettingsRoute
  '/master/brand-lines': typeof MasterBrandLinesRoute
  '/master/brands': typeof MasterBrandsRoute
  '/master/categories': typeof MasterCategoriesRoute
  '/result/$id': typeof ResultIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/master': typeof MasterRouteWithChildren
  '/settings': typeof SettingsRoute
  '/master/brand-lines': typeof MasterBrandLinesRoute
  '/master/brands': typeof MasterBrandsRoute
  '/master/categories': typeof MasterCategoriesRoute
  '/result/$id': typeof ResultIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history'
    | '/login'
    | '/master'
    | '/settings'
    | '/master/brand-lines'
    | '/master/brands'
    | '/master/categories'
    | '/result/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history'
    | '/login'
    | '/master'
    | '/settings'
    | '/master/brand-lines'
    | '/master/brands'
    | '/master/categories'
    | '/result/$id'
  id:
    | '__root__'
    | '/'
    | '/history'
    | '/login'
    | '/master'
    | '/settings'
    | '/master/brand-lines'
    | '/master/brands'
    | '/master/categories'
    | '/result/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryRoute: typeof HistoryRoute
  LoginRoute: typeof LoginRoute
  MasterRoute: typeof MasterRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  ResultIdRoute: typeof ResultIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master': {
      id: '/master'
      path: '/master'
      fullPath: '/master'
      preLoaderRoute: typeof MasterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/result/$id': {
      id: '/result/$id'
      path: '/result/$id'
      fullPath: '/result/$id'
      preLoaderRoute: typeof ResultIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master/categories': {
      id: '/master/categories'
      path: '/categories'
      fullPath: '/master/categories'
      preLoaderRoute: typeof MasterCategoriesRouteImport
      parentRoute: typeof MasterRoute
    }
    '/master/brands': {
      id: '/master/brands'
      path: '/brands'
      fullPath: '/master/brands'
      preLoaderRoute: typeof MasterBrandsRouteImport
      parentRoute: typeof MasterRoute
    }
    '/master/brand-lines': {
      id: '/master/brand-lines'
      path: '/brand-lines'
      fullPath: '/master/brand-lines'
      preLoaderRoute: typeof MasterBrandLinesRouteImport
      parentRoute: typeof MasterRoute
    }
  }
}

interface MasterRouteChildren {
  MasterBrandLinesRoute: typeof MasterBrandLinesRoute
  MasterBrandsRoute: typeof MasterBrandsRoute
  MasterCategoriesRoute: typeof MasterCategoriesRoute
}

const MasterRouteChildren: MasterRouteChildren = {
  MasterBrandLinesRoute: MasterBrandLinesRoute,
  MasterBrandsRoute: MasterBrandsRoute,
  MasterCategoriesRoute: MasterCategoriesRoute,
}

const MasterRouteWithChildren =
  MasterRoute._addFileChildren(MasterRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryRoute: HistoryRoute,
  LoginRoute: LoginRoute,
  MasterRoute: MasterRouteWithChildren,
  SettingsRoute: SettingsRoute,
  ResultIdRoute: ResultIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
